import React, { useEffect, useState } from "react";
import { usePhrase } from "@/contexts/LanguageContext";
import { api, formatINR } from "@/lib/api";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";

const STAGES = ["Scheme identified","Application preparation","Application submitted","Acknowledgement received","Preliminary approval","Investment initiated","Commercial production commenced","Inspection requested","Inspection completed","Claim submitted","Query raised","Query resolved","Benefit sanctioned","Benefit released","Partially released","Rejected","Appeal or representation","Closed"];

export default function SubsidyTracker() {
  const pt = usePhrase();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/subsidy-tracking").then((r) => setItems(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="subsidy-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 brand-heading">{pt("Subsidy Tracker")}</h1>
        <p className="text-slate-600 mt-1 text-sm">{pt("Track scheme benefit stages after disbursement. Estimated ≠ approved.")}</p>
      </div>
      <div className="space-y-4">
        {items.map((it) => {
          const stageIdx = STAGES.indexOf(it.current_stage);
          return (
            <div key={it.id} className="p-6 rounded-lg border border-slate-200 bg-white" data-testid={`sub-${it.id}`}>
              <div className="flex items-baseline justify-between gap-2 flex-wrap">
                <div>
                  <div className="font-semibold text-slate-900 brand-heading">{it.scheme_name}</div>
                  <div className="text-xs text-slate-500">{pt("Ref:")} {it.application_reference} · {pt("Authority:")} {it.responsible_authority}</div>
                </div>
                <div className="text-right">
                  <div className="text-xs text-slate-500">{pt("Expected")}</div>
                  <div className="font-bold text-slate-900">{formatINR(it.expected_benefit)}</div>
                </div>
              </div>
              <div className="mt-4">
                <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                  <div className="h-full bg-emerald-500" style={{ width: `${((stageIdx + 1) / STAGES.length) * 100}%` }} />
                </div>
                <div className="mt-2 text-xs text-slate-600">{pt("Current stage:")} <span className="font-semibold text-slate-900">{pt(it.current_stage)}</span></div>
              </div>
              <div className="mt-3 grid grid-cols-3 gap-3 text-xs">
                <div><div className="text-slate-500">{pt("Expected")}</div><div className="font-semibold">{formatINR(it.expected_benefit)}</div></div>
                <div><div className="text-slate-500">{pt("Approved")}</div><div className="font-semibold">{formatINR(it.approved_benefit)}</div></div>
                <div><div className="text-slate-500">{pt("Received")}</div><div className="font-semibold">{formatINR(it.received_benefit)}</div></div>
              </div>
            </div>
          );
        })}
        {items.length === 0 && <div className="text-sm text-slate-500">{pt("No scheme benefit tracking yet.")}</div>}
      </div>
      <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs text-amber-900">
        {pt("Estimated benefit is not an approved benefit. Benefit approval and release are determined by the competent department under the applicable notification.")}
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
